app.controller('LoginCtrl', ['$scope', '$rootScope', '$window', '$http', '$q', 'appFactory',
    function ($scope, $rootScope, $window, $http, $q, appFactory) {

    var allPromise = $q.all([

        // check login, jika ada session, maka pergi ke stage saat itu.
        $scope.checkLogin()
    ]);


    allPromise.then(function () {

    });

    $scope.user = {};

    // toggle password plaintext
    $scope.showPassword = false;
    $scope.inputType = 'password';
    $scope.toggleShowPassword = function () {
        $scope.showPassword = !$scope.showPassword;
        if ($scope.inputType == 'password')
            $scope.inputType = 'text';
        else
            $scope.inputType = 'password';
    }

    // saat tombol login di submit
    $scope.submit = function () {

        appFactory.postGetData(
            `service/client.svc/LoginUser`,
            'POST',
            { UserLogin: $scope.user }
        ).then(function (data) {

            if (data.status == 200) {

                $scope.result = data.data.d;

                var SWALtranslate = $scope.SWALtranslate($scope.result.message);

                // login ok
                if ($scope.result.result) {

                    console.log($scope.result)

                    $scope.checkLoginStep($scope.result);
                    return;
                }

                // ===== TAMBAHKAN BARIS INI =====
                // Kosongkan password setelah login gagal
                $scope.user.Email = '';
                $scope.user.Password = '';
                // ===============================

                // if user not activated, open sweet alert with footer
                if ($scope.result.message == "notactivated") {

                    Swal.fire({
                        title: SWALtranslate.title,
                        icon: 'warning',
                        footer: `<small><a id="resendOTP" >${SWALtranslate.footer}</a></small>`,
                        html: `${SWALtranslate.message}<div id="recaptcha" style="margin-top: 20px; display: flex; justify-content: center; align-items: center; flex-direction: column; overflow:hidden;"></div>`,
                        showConfirmButton: false,
                        timer: 0,
                        willOpen: function () {
                            grecaptcha.render('recaptcha', {
                                'sitekey': '6Lc14WsrAAAAAGojsrr_4Y1EPdelKNui9eIpri4K'
                            });
                        },
                        preConfirm: function () {
                            if (grecaptcha.getResponse().length === 0) {
                                Swal.showValidationMessage(`Please verify that you're not a robot`)
                            }
                        }
                    })

                    //Swal.fire({
                    //    footer: `<small><a id="resendOTP" >${SWALtranslate.footer}</a></small>`,
                    //    icon: 'warning',
                    //    title: SWALtranslate.title,
                    //    html: `XX <div class="g-recaptcha" data-sitekey="6LemM0QpAAAAALz6-53wlzdOAUSb1AauoDJLmbtv"></div>OO`,
                    //    timer: 0,
                    //    showConfirmButton: false,
                    //})

                    //$rootScope.AlertShowFooter('warning', SWALtranslate.title, SWALtranslate.message,
                    //    `<small><a id="resendOTP" >` + SWALtranslate.footer + `</a></small>`, 0);

                    $("#resendOTP").on("click", function () {

                        //ecnrypt email
                        var key = CryptoJS.enc.Utf8.parse('123456789qwertyu'); // Panjang 16 byte untuk AES-128
                        var iv = CryptoJS.enc.Utf8.parse('qwerty0987654321'); // Juga 16 byte

                        var plaintext = $scope.user.Email;

                        var encrypted = CryptoJS.AES.encrypt(plaintext, key, {
                            iv: iv,
                            mode: CryptoJS.mode.CBC,
                            padding: CryptoJS.pad.Pkcs7
                        });

                        //captcha
                        var challenge = grecaptcha.getResponse();
                        if (!challenge) {
                            alert("Mohon ulangi centang captcha");
                            return false;
                        }

                        //send request resendOTP
                        var data = {
                            Email: encrypted.toString(),
                            challenge: challenge
                        }

                        // dynamic sweet alert post to app.js
                        // 1: set the url of post or get request
                        // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
                        // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
                        // 4: set the method to $http request = "GET" / "POST"
                        // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
                        // 6: if success or no error returns then...
                        var urlsvc = 'service/client.svc/resendOTP'; // 1
                        var preconfirmtranslate = "resendactivationlink"; // 2 
                        var postData = { User: data }; // 3
                        var method = "POST"; // 4
                        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

                            if (issuccess) // 6 
                                $window.location.href = "#/login";
                        });
                    });
                    return
                }

                // login not ok
                $rootScope.GlobalAlert('warning', SWALtranslate.title, SWALtranslate.message, 0);
            }
        });
    };
}]);
